module.exports = __webpack_public_path__ + "static/media/badge-3.8d66f469.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/home-player-dashboard/progress-map/widgets/badges/badge-3.png
// module id = 1205
// module chunks = 0